import { NotificationPageService } from './service/notification-page.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from './../../services/notification/notification.service';
import { LabelsService } from './../../util/services/labels/labels.service';
import { Component, OnInit } from '@angular/core';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { accordionInterface } from 'src/app/util/interfaces/accordion';
import { notificationInterface } from 'src/app/util/interfaces/notification';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-notification-page',
	templateUrl: './notification-page.component.html',
	styleUrl: './notification-page.component.scss',
})
export class NotificationPageComponent implements OnInit {
	icons = {};

	labels: LabelsInterface = {
		lbl_geral_notificacoes: '',
		lbl_selecione_uma_opcao: '',
		lbl_edocs_carregando: '',
		lbl_geral_inicio: '',
		lbl_geral_nao_existem_notificacoes: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private ActivatedRoute: ActivatedRoute,
		private NotificationPageService: NotificationPageService,
		public PermissionService: PermissionService,
		public ProfileService: ProfileService
	) {}

	isLabelsLoading = true;
	isAccordionLoading = true;

	notificationAccordion: accordionInterface[];

	selectedAccordion: accordionInterface = {
		id: '',
		name: '',
		notification: [],
		type: undefined,
		dataType: 'notification',
		border: '',
		alert: false,
		accordionLength: 0,
		hidden: false,
	};

	selectedNotification: notificationInterface = {
		id: '',
		customer: undefined,
		type: '',
		summary: '',
		description: '',
		limit_date: '',
	};

	ghostResizeBar = {
		mouseDown: false,
		startX: null,
		mainCol: 40,
		subCol: 60,
	};

	secondColView = 'not-chosen';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe({
			next: (labels) => {
				this.labels = labels;
			},
			complete: () => {
				this.isLabelsLoading = false;
			},
		});

		this.getNotificationsAccordions();
	}

	getNotificationsAccordions(): void {
		this.cleanNotificationAccordion();
		this.NotificationPageService.getNotificationsAccordion().subscribe({
			next: (notificationAccordion) => {
				this.notificationAccordion = notificationAccordion;
			},
			complete: () => {
				this.isAccordionLoading = false;
			},
		});
	}

	cleanNotificationAccordion(): void {
		this.selectedAccordion = {
			id: '',
			name: '',
			notification: [],
			type: undefined,
			dataType: 'notification',
			border: '',
			alert: false,
			accordionLength: 0,
			hidden: false,
		};
	}

	cleanNotification(): void {
		this.selectedNotification = {
			id: '',
			customer: undefined,
			type: '',
			summary: '',
			description: '',
			limit_date: '',
		};
	}

	changeHistory(newHistory: string): void {
		window.history.replaceState(null, '', newHistory);
	}

	selectNotification(idNotification: string) {
		this.cleanNotification();
		this.selectedNotification = this.selectedAccordion.notification.find((notification) => notification.id == idNotification);

		this.markNotificationRead(idNotification);
	}

	formartDescription(description: string): string {
		const formatedDescription = this.decodeHtmlEntities(description.replaceAll(/<[^>]+>/g, ''));
		return formatedDescription.length > 47 ? formatedDescription.slice(0, 45) + '..' : formatedDescription;
	}

	decodeHtmlEntities(description: string) {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = description;
		return textarea.value;
	}

	handleGhostResizeBar(e: MouseEvent): void {
		if (!this.ghostResizeBar.mouseDown) return;
		this.ghostResizeBar.subCol = 100 - (e.pageX / (window.innerWidth + 64)) * 100;
		this.ghostResizeBar.mainCol = (e.pageX / (window.innerWidth + 64)) * 100;
	}

	markNotificationRead(idNotification: string): void {
		const storedItems = localStorage.getItem('notifications');
		if (storedItems) {
			const notifications: { id: string; read: boolean }[] = JSON.parse(storedItems);

			const notificationIndex = notifications.findIndex((notification) => notification.id === idNotification);
			if (notificationIndex !== -1) {
				notifications[notificationIndex].read = true;
			}

			localStorage.setItem('notifications', JSON.stringify(notifications));
			this.markAllNotificationsReaded();
		}
	}

	markAllNotificationsReaded(): void {
		const storedItems = localStorage.getItem('notifications');
		const notifications: { id: string; read: boolean }[] = JSON.parse(storedItems);

		const allReaded = notifications.every((notification) => notification.read);
		if (allReaded) {
			const svgElement = document.querySelector('a.side-bar-item.warning');
			if (svgElement) svgElement.classList.remove('warning');
		}
	}

	isCardNewNotification(idNotification: string): boolean {
		const storedItems = localStorage.getItem('notifications');
		const notifications: { id: string; read: boolean }[] = storedItems ? JSON.parse(storedItems) : [];

		const notification = notifications.find((notification) => notification.id === idNotification);
		return notification ? !notification.read === true : false;
	}
}
